import { Component, OnInit } from '@angular/core';
import { TestimonialsService } from './testimonials.service';

declare var $: any;

@Component({
  selector: 'zest-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit {

  public testimonials = [];
  public slickConfiguration: object = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  constructor(private testimonialsService: TestimonialsService) { }

  ngOnInit() {
    this.testimonialsService.getTestimonials().subscribe(response => {
      this.testimonials = response.testimonials;
      setTimeout(fn => {
        $('.zest-slick-slider').slick(this.slickConfiguration);
      }, 0);
    });
  }

}
